/*
 * Copyright (C) COMPOFFICE-R Kft, RentIT - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 *
 */
RCA.client.Attendees = (function () {
    'use strict';
    /* ----- Declare Variables ---------------------------------------------------------------------------------------- */
    var $templateAttendeesItem,
        pageCount = 20;
    RCA.shared.localState.attendees = RCA.shared.localState.attendees || {};
    RCA.shared.localState.attendees.itemIndex = RCA.shared.localState.attendees.itemIndex || 0;
    RCA.shared.localState.attendees.page = 0;

    /* ----- Init Attendees -------------------------------------------------------------------------------------------- */
    function Init() {
        $templateAttendeesItem = $('template#tplAttendeesItem').remove().contents();
        $(document).on('input', '#attendees .search-wrapper input', evtInput);
        $(document).on('keyup', '#attendees .search-wrapper input', evtPressEnter);
        $(document).on('click', '#attendees .search-wrapper .btn-clear', evtClear);
        $(document).on('click', '#attendees #attendeesList .item', evtClick);
        $(document).on('click', '#attendees #attendeesList .load-more', loadMore);
        $(document).on('click', '#attendees-details .attendees-card-request', evtClickBusinessCard);
        $(document).on('click', '#attendees-details .start_chat', startChat);
        $(document).on('click', '#attendees-details .favorite.save', evtClickFavorite);
        $(document).on('click', '#attendees-details .favorite.cancel', evtClickCancelFavorite);
        $(document).on('click', '#attendees-details .external-link', openExternalLink);
        if ('search' in RCA.shared.localState.attendees && RCA.shared.localState.attendees.search !== "") {
            $('#attendees .search-wrapper input').val(RCA.shared.localState.attendees.search).trigger('input');
        } else  {
            loadMore();
        }

        RCA.client.clientEventListeners.push({
            type: 'open',
            event_name: 'attendees_opened'
        });

        RCA.client.clientEventListeners.push({
            type: 'swap',
            event_name: 'attendees_opened'
        });

        $(document).on('attendees_opened', function (){

            if (RCA.shared.AppData.modulsettings.attendeeshowarrived) {
                $.ajax({
                    url: 'api/',
                    method: 'post',
                    data: {
                        do: 'getArrivedUsers'
                    },
                    success: function (data) {
                        $("#attendeesList .arrived").removeClass("arrived");

                        for (let i = 0; i < data.arrived_users.length; i++) {
                            $("#attendeesList [data-index='" + data.arrived_users[i] + "'] .info").addClass("arrived");
                        }
                    }
                });
            }
        });
    }

    function sort() {
        RCA.shared.AppData.user_fields.sort(function (a, b) {
            if (a.sort_id !== undefined && b.sort_id !== undefined) {
                return parseInt(a.sort_id) > parseInt(b.sort_id) ? 1 : -1;
            } else {
                return 0;
            }
        });
    }

    function addUserFields(data) {
        sort();
        var clientUserFields = RCA.shared.AppData.user_fields.filter(function(el) {
                return el.is_active === true;
            }),
            div,
            icon,
            section;

        $("#attendees-details .custom_fields").html("");
        $.each(clientUserFields, function(i,el) {
            section = $("<section/>");
            section.addClass("item " + (el.field_type === "text" ? "text-center" : "text-justify"));
            div = $("<div/>");
            section.append(div);

            icon = "";
            if(el.field_icon !== "") {
                icon = "<i class='" + el.field_icon + "'></i> ";
            }
            if(el.field_translated) {
                if(data && data.values[el.field_name].title !== '') {
                    div.html(icon + data.values[el.field_name].title[RCA.shared.localState.lang]);
                    $("#attendees-details .custom_fields").append(section);
                }
            } else {
                if(data && data.values[el.field_name].title !== '') {
                    div.html(icon + data.values[el.field_name].title);
                    $("#attendees-details .custom_fields").append(section);
                }
            }
            // if(data && data.values[el.field_name].title !== undefined) {
            //     div.html(el.translated ? data.values[el.field_name].title[localState.lang] : data.values[el.field_name].title);
            // }
        });
    }

    function openExternalLink() {
        var link = $(this).attr("data-link");
        window.open(link);
    }

    /* ----- Sort List ------------------------------------------------------------------------------------------------ */
    function sortList() {
        RCA.shared.AppData.attendees.sort(function (a, b) {
            return String(a.name[RCA.shared.localState.lang]).localeCompare(String(b.name[RCA.shared.localState.lang]));
        });
    }

    /* ----- Build Attendees List -------------------------------------------------------------------------------------- */
    function renderList() {
        var
            $self = $('#attendees #attendeesList'),
            $fragmentAttendees = $(document.createDocumentFragment());
        /* Set Agenda List */
        $.each(RCA.shared.AppData.attendees, function (i, el) {
            if (el.active) {
                var
                    $clone = $templateAttendeesItem.clone(),
                    info = [];
                $.each(el.values, function(i,e) {
                    if (e.showrow == '1' && e.is_active) {
                        info.unshift(typeof e.title == "object" ? e.title[RCA.shared.localState.lang] : e.title);
                    } else if (e.showrow == '2' && e.is_active) {
                        info.push(typeof e.title == "object" ? e.title[RCA.shared.localState.lang] : e.title);
                    }

                    if (RCA.shared.AppData.modulsettings.attendeeshowarrived) {
                        $clone.find('.info').addClass("show_arrived");
                    } else {
                        $clone.find('.info').removeClass("show_arrived");
                    }

                    if (i == "arrived" && e.title == 1) {
                        $clone.find('.info').addClass("arrived");
                    }
                });

                $clone.attr('data-index', el.id);
                $clone.find('.data-name').html(el.name[RCA.shared.localState.lang]);
                $clone.find('.data-info').html(info.join('<br>')).toggleClass('hidden', !info.length || !RCA.shared.AppData.modulsettings.attendeeshowinfo);
                if (el.img || false) {
                    $clone.find('.data-img').attr(($self.is(':visible')) ? 'src' : 'data-src', 'upload/users/' + el.img + '?r=' + (new Date().getTime()));
                } else {
                    $clone.find('.data-img').attr('src', 'img/profile-picture-placeholder.png');
                }
                $clone.appendTo($fragmentAttendees);
            }
        });

        let morecont = $("<div/>").addClass("more-cont");
        let morebtn = $("<button/>").addClass("btn load-more").html(RCA.shared.Language.getItem("load-more"));

        morebtn.appendTo(morecont);
        morecont.appendTo($fragmentAttendees);

        $self.html($fragmentAttendees);
    }

    function loadMore() {
        $("#attendees #attendeesList .load-more").addClass("disabled").prop("disabled", true).show();

        $.ajax({
            method: 'post',
            url: 'api/',
            data: {
                do: "loadMoreAttendees",
                page: RCA.shared.localState.attendees.page,
                lang: RCA.shared.localState.lang
            },
            success: function (response) {
                $("#attendees #attendeesList .load-more").removeClass("disabled").prop("disabled", false);
                RCA.shared.localState.attendees.page++;
                RCA.shared.AppData.attendees = RCA.shared.AppData.attendees.concat(response['attendees']);
                RCA.shared.AppData.user_fields = response.user_fields;

                UpdateModule();

                if(response.count === 0 ||  response.count <= (RCA.shared.localState.attendees.page * pageCount) ) {
                    $("#attendees #attendeesList .load-more").hide();
                } else {
                    $("#attendees #attendeesList .load-more").show();
                }
                $('#attendees .no-result').toggle(response.count === 0);
            }, error: function () {
                $("#attendees #attendeesList .load-more").removeClass("disabled").prop("disabled", false);
            }
        });
    }

    function toggleRequestBusinessCard(user) {
        if(RCA.shared.AppData.modulsettings.showexchangeprofileattendees && user.pubEmail && user.pubProfile) {
            $("#attendees-details").find(".favorite").show();
        } else {
            $("#attendees-details").find(".favorite").hide();
        }
    }

    function toggleSocial() {
        if(RCA.shared.AppData.modulsettings.showsociallinks) {
            $("#attendees-details").find(".social").show();
        } else {
            $("#attendees-details").find(".social").hide();
        }
    }

    /* ----- Build Details -------------------------------------------------------------------------------------------- */
    function renderDetails() {
        if ('attendees' in RCA.shared.localState) {
            var
                $attendee = $('#attendees-details article'),
                $header = $('#attendees-details .data-label'),
                state = RCA.shared.localState.attendees,
                item = RCA.shared.AppData.favorites.find(function (item) {
                    return item.type === 'attendee' && item.data === RCA.shared.localState.attendees.itemIndex
                }),
                saved = Boolean(item),
                undo = Boolean(item) && !item.sent,
                el = RCA.shared.AppData.attendees.find(function (el) {
                    return el.id === RCA.shared.localState.attendees.itemIndex
                });

            if (!el) {
                return false;
            }
            $header.html(el.name[RCA.shared.localState.lang]);

            $attendee.find('.data-img').attr({
                'src': 'img/profile-picture-placeholder.png',
                'data-src': null
            });
            if (el.img || false) {
                $attendee.find('.data-img').attr('src', 'upload/users/' + el.img);
            }
            var
                phone  = el.phone ? atob(atob(el.phone).substring(1)) : '',
                email  = el.email ? atob(atob(el.email).substring(1)) : '';

            let fb = el.facebook_url ? el.facebook_url : '';
            let tw = el.twitter_url ? el.twitter_url : '';
            let ins = el.instagram_url ? el.instagram_url : '';
            let li = el.linkedin_url ? el.linkedin_url : '';

            $attendee.find('.facebook').attr("data-link", fb).toggleClass('hidden', !fb);
            $attendee.find('.twitter').attr("data-link", tw).toggleClass('hidden', !tw);
            $attendee.find('.instagram').attr("data-link", ins).toggleClass('hidden', !ins);
            $attendee.find('.linkedin').attr("data-link", li).toggleClass('hidden', !li);

            $attendee.find('.social').toggleClass('hidden', !fb && !tw && !ins && !li);

            $attendee.find('.data-name').html(el.name[RCA.shared.localState.lang]);
            $attendee.find('.data-job').html(el.job[RCA.shared.localState.lang]).toggleClass('hidden', !el.job[RCA.shared.localState.lang]);
            $attendee.find('.data-company').html(el.company[RCA.shared.localState.lang]).toggleClass('hidden', !el.company[RCA.shared.localState.lang]);

            $attendee.find('.data-phone').html(phone).parent().toggleClass('hidden', !phone);
            $attendee.find('.data-email').html(email).parent().toggleClass('hidden', !email);

            $attendee.find('.data-slogan').html(RCA.client.nl2br(el.slogan[RCA.shared.localState.lang])).parent().toggleClass('hidden', !el.slogan[RCA.shared.localState.lang]);
            $attendee.find('.data-department').html(RCA.client.nl2br(el.department[RCA.shared.localState.lang])).parent().toggleClass('hidden', !el.department[RCA.shared.localState.lang]);
            $attendee.find('.data-university').html(RCA.client.nl2br(el.university[RCA.shared.localState.lang])).parent().toggleClass('hidden', !el.university[RCA.shared.localState.lang]);
            $attendee.find('.data-skill').html(RCA.client.nl2br(el.skill[RCA.shared.localState.lang])).parent().toggleClass('hidden', !el.skill[RCA.shared.localState.lang]);
            $attendee.find('.data-bio').html(RCA.client.nl2br(el.bio[RCA.shared.localState.lang])).toggleClass('hidden', !el.bio[RCA.shared.localState.lang]);

            $attendee.find('.listing').toggleClass('hidden', !phone && !email);
            $attendee.find('.social').toggleClass('hidden', !fb && !tw && !ins && !li);

            // $attendee.find('#attendees-card-request').attr('data-id', el.id);
            $attendee.find('.favorite.save').toggleClass('hidden', saved);
            $attendee.find('.favorite.saved').toggleClass('hidden', !saved);
            $attendee.find('.favorite.cancel').toggleClass('hidden', !undo);

            phone = email = null;

            var chat_allowed = RCA.shared.AppData.navigation.find(function (item) {
                return item.module == "chat" && item.visible && RCA.shared.AppData.profile.id != el.id;
            });

            if (chat_allowed) {
                $(".start_chat").parent().show();
            } else {
                $(".start_chat").parent().hide();
            }

            addUserFields(el);
            toggleRequestBusinessCard(el);
            toggleSocial();
        }
    }

    /* ----- Event: Click on Item ------------------------------------------------------------------------------------- */
    function evtClickFavorite() {
        var $self = $('#attendees-details');
        $self.find('.favorite.save').addClass('hidden');
        $self.find('.favorite.saved').removeClass('hidden');
        $self.find('.favorite.cancel').removeClass('hidden');
        $.post('api/', {
            do: 'saveFavoriteAttendee',
            data: {'id' : RCA.shared.localState.attendees.itemIndex || false, 'lang': RCA.shared.localState.lang}
        }, function (res) {
            RCA.shared.AppData.favorites = res;
            RCA.client.Modal.resultconfirmation(
                {"canClose": true,
                    "title": RCA.shared.AppData.languages[RCA.shared.localState.lang].businesscardrequest_title,
                    "text":  RCA.shared.AppData.languages[RCA.shared.localState.lang].businesscardrequest_text
                }
            );
            res = null;
        });
        $self = null;
    }

    function evtClickCancelFavorite() {
        var
            $self = $('#attendees-details'),
            saved = RCA.shared.AppData.favorites.find(function (item) {
                return item.type === 'attendee' && item.data === RCA.shared.localState.attendees.itemIndex
            });
        $self.find('.favorite.save').removeClass('hidden');
        $self.find('.favorite.saved').addClass('hidden');
        $self.find('.favorite.cancel').addClass('hidden');
        $.post('api/', {
            do: 'removeFavorite',
            data: saved.id
        }, function (res) {
            RCA.shared.AppData.favorites = res;
            res = null;
        });
        $self = null;
    }

    /* ----- Build from File ------------------------------------------------------------------------------------------ */
    function BuildFromSource() {
        RCA.shared.AppData.attendees = [];
        RCA.shared.localState.attendees.page = 0;
        loadMore();
    }

    function UpdateModule() {
        sortList();
        renderList();
        renderDetails();
    }

    /* ----- Update Avatar -------------------------------------------------------------------------------------------- */
    function updateAvatar(img) {
        $("#attendees [data-index='"+img.id+"'] .data-img").attr('src', img.img+"?r="+Math.random());
        let userindex = RCA.shared.AppData.attendees.findIndex(function (item) {
            return item.id == img.id;
        });

        if (userindex > -1) {
            let imgname = img.img.split("/");
            RCA.shared.AppData.attendees[userindex].img = imgname[imgname.length - 1];
        }
    }

    function updateUser(data) {
        let userindex = RCA.shared.AppData.attendees.findIndex(function (item) {
            return item.id == data.id;
        });

        if (userindex > -1 && data.udata.length > 0) {
            RCA.shared.AppData.attendees[userindex] = data.udata[0];
            UpdateModule();
        } else {
            BuildFromSource();
        }
    }

    /* ----- Event: Input on Search ----------------------------------------------------------------------------------- */
    function evtInput(e) {
        var
            isResult = false,
            $btnClear = $('#attendees .search-wrapper .btn-clear'),
            $noResult = $('#attendees .no-result'),
            value = $('#attendees .search-wrapper input').val(),
            search = value.split(' ').join(''),
            regex1 = new RegExp(RCA.shared.strCanonical(search), 'i'),
            regex2 = new RegExp(RCA.shared.strCanonical(search), 'i');
        RCA.shared.localState.attendees.search = value;
        requestAnimationFrame(function () {
            if(search.length > 1) {
                $.ajax({
                    method: 'post',
                    url: 'api/',
                    data: {
                        do: "searchAttendees",
                        search: value.split(' '),
                        lang: RCA.shared.localState.lang
                    },
                    success: function (response) {
                        RCA.shared.AppData.attendees = response;
                        UpdateModule();
                        $btnClear.toggle(Boolean(value.length));
                        $noResult.toggle(!Boolean(response.length));
                        $("#attendees #attendeesList .load-more").hide();
                        isResult = $btnClear = $noResult = value = search = regex1 = regex2 = null;
                    }, error: function (error) {
                        console.log("error", error);
                    }
                });
            } else if(search.length === 0) {
                $btnClear.trigger('click');
            }
        });
    }

    /* ----- Event: Click on Item ------------------------------------------------------------------------------------- */
    function evtClick() {
        RCA.shared.localState.attendees.itemIndex = String($(this).data('index')) || 0;
        renderDetails();
        RCA.shared.writeDbLog("show attendee profile", RCA.shared.localState.attendees.itemIndex, "user_logs", "users");
        RCA.client.Layout.show('attendees-details');
    }

    function startChat() {
        RCA.client.Chat.showChat("new_room", RCA.shared.localState.attendees.itemIndex);
    }

    /* ----- Event: Click on Item ------------------------------------------------------------------------------------- */
    function evtClear(e) {
        e.preventDefault();
        var $input = $('#attendees .search-wrapper input');
        $input.val('');
        RCA.shared.localState.attendees.search = "";
        RCA.shared.localState.attendees.page = 0;
        $('#attendees .search-wrapper .btn-clear').hide();
        $.post('api/', {
            do: "loadMoreAttendees",
            multipage: "true",
            lang: RCA.shared.localState.lang,
            page: RCA.shared.localState.attendees.page
        }, function(response) {
            RCA.shared.AppData.attendees = response.attendees;
            UpdateModule();
            if(response.count === 0 ||  response.count <= (RCA.shared.localState.attendees.page * pageCount) ) {
                $("#attendees #attendeesList .load-more").hide();
            } else {
                $("#attendees #attendeesList .load-more").show();
            }
            $('#attendees .no-result').toggle(response.count === 0);        });
    }

    /* ----- Event: Press Enter --------------------------------------------------------------------------------------- */
    function evtPressEnter(e) {
        if (e.wich || e.keyCode === 13) {
            this.blur();
        }
    }

    function evtClickBusinessCard(e) {

        $.post('api/', {
            do: 'saveBusinessCard',
            data: {"id": e.target.dataset.id, "lang": RCA.shared.localState.lang}
        }, function (res) {
            // AppData.favorites = res;
            // console.log(res);
            RCA.client.Modal.resultconfirmation(
                {"canClose": true,
                      "title": RCA.shared.AppData.languages[RCA.shared.localState.lang].businesscardrequest_title,
                      "text":  RCA.shared.AppData.languages[RCA.shared.localState.lang].businesscardrequest_text
                      }
            );
            res = null;
        });
        // $self = null;

    }

    function showDetails(id) {
        if (id) {
            if (RCA.shared.localState.attendees != undefined) {
                if (id !== RCA.shared.localState.attendees.itemIndex || RCA.shared.localState.attendees.itemIndex === 0) {
                    RCA.shared.localState.attendees.itemIndex = String(id);
                    renderDetails();
                }
            } else {
                RCA.shared.localState.attendees = { 'itemIndex': String(id)};
            }
            RCA.client.Layout.show('attendees-details');
        }
    }

    /* ----- updateRequestBusinessCard ------------------------------------------------------------------------------ */
    function updateRequestBusinessCard() {
        $.post('api/', {
            do: 'getFavorites'
        }, function (data) {
            RCA.shared.AppData.favorites = data;
            renderDetails();
            data = null;
        })
    }

    /* ----- Public API ----------------------------------------------------------------------------------------------- */
    return {
        Init: Init,
        evtClickDetails: evtClick,
        renderList: renderList,
        showDetails: showDetails,
        BuildFromSource: BuildFromSource,
        updateAvatar: updateAvatar,
        updateUser: updateUser,
        UpdateModule: UpdateModule,
        toggleRequestBusinessCard: toggleRequestBusinessCard,
        updateRequestBusinessCard: updateRequestBusinessCard,
        toggleSocial: toggleSocial
    };
})();
